import styled from "styled-components";
import Modal from "../../components/Modal";
import { useContext, useEffect, useMemo, useState } from "react";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ClickableIcon } from "../../components/Icon";
import Button from "../../components/Button";
import Status from "../../types/enum/Status";
import { Icon } from "@mui/material";

type SelecteAnnouncementModal = {
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  setAnnouncement: (x: any) => void;
  announcement: any;
};
export const SelectAnnouncementModal = ({
  isOpen,
  setOpen,
  setAnnouncement,
  announcement,
}: SelecteAnnouncementModal): JSX.Element => {
  const HeaderBox = styled(FlexBox)`
    display: flex;
    align-items: center;
    padding: 12px 12px;
    background: #090d20;
    font-weight: bold;
    color: #ffffff;
  `;
  const StyledBody = styled("div")`
    padding: 12px 12px;
    // background: #ecc5c61a;
    background: #090d20;
    color: #dfdfdf;
  `;
  const InnerBody = styled("div")`
    padding: 12px 12px;
    background: #ababab1a;
    border-radius: 5px;
    margin-bottom: 12px;
  `;
  const ContentStyle = styled("div")`
    overflow-y: auto;
    max-height: 50vh;
    margin-bottom: 12px;
    white-space: pre-wrap;
  `;
  const Title = styled("div")`
    color: #ffffff;
    font-weight: bold;
    font-size: 1.2rem;
  `;

  const PostedStyle = styled("div")`
    color: #cdcdcd;
    padding-bottom: 12px;
    font-size: 12px;
    font-weight: normal;
  `;
  console.log(announcement);
  return (
    <Modal
      isOpen={isOpen || false}
      setOpen={setOpen}
      customStyle={{
        content: {
          maxWidth: "800px",
          padding: 0,
          background: "#090d20",
          // border: "1px solid #2D416C",
          boxShadow: "0px 4px 16px rgba(0,0,0)",
          borderRadius: "8px",
        },
      }}
    >
      <HeaderBox>
        <Icon
          sx={{
            color: "#ffff86",
            mr: 1,
            textShadow: "0 1px 5px black",
          }}
        >
          campaign
        </Icon>
        <FlexGrow>{announcement.announcement_category}</FlexGrow>
        <ClickableIcon
          name="times"
          onClick={() => setOpen(false)}
          style={{ color: "white" }}
        />
      </HeaderBox>
      {/* <div style={{height:1, background:'#2D416C', marginLeft:12,marginRight:12}}/> */}
      <StyledBody>
        <InnerBody>
          <Title>
            {announcement.title}
            <PostedStyle>
              Posted {announcement.date_created} by {announcement.creator}
            </PostedStyle>
          </Title>
          <ContentStyle className="visible-scrollbar">
            {announcement.content}
          </ContentStyle>
          {announcement.url && announcement.url !== "" && (
            <>
              URL :
              <a href={announcement.url} style={{ color: "#3a7efe" }}>
                {" "}
                {announcement.url}
              </a>
            </>
          )}
        </InnerBody>
        <FlexBox justify="end">
          <Button
            style={{
              // border:'1px solid blue',
              width: "151px",
              height: "48px",
              padding: "13px 12px",
            }}
            isOutline
            onClick={() => {
              setOpen(false);
            }}
            status={Status.default}
          >
            Dismiss
          </Button>
        </FlexBox>
      </StyledBody>
    </Modal>
  );
};
